export default __webpack_public_path__ + "static/media/dev-mode.adb7bb62.webp";